<script setup lang="ts">
import PartnerButtonRedirect from '@/components/common/buttons/PartnerButtonRedirect.vue'
import CreditSafeWithUpdateButton from '@/components/common/buttons/CreditSafeWithUpdateButton.vue'
import { type PartnerProjection } from '@/api-swagger'
import SearchPartnerInput from '@/components/features/partners/SearchPartnerInput.vue'
import { ref, watch } from 'vue'

defineProps({
  partner: {
    type: Object as () => PartnerProjection | null | undefined,
    required: false,
  },
  isEditable: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:choosenPartner'])

const errors = ref<Record<string, string>>({})
const choosenPartner = ref<number | undefined>(undefined)

watch(choosenPartner, (newValue) => {
  if (newValue !== undefined) {
    emit('update:choosenPartner', newValue)
  }
})
</script>

<template>
  <div class="card bg-base-100 border w-full">
    <div class="card-body p-4">
      <div class="flex flex-col md:flex-row justify- items-center md:items-center gap-4">
        <div class="flex flex-col">
          <h3 class="card-title text-base mb-2" v-if="!isEditable && partner">
            <div class="label">
              <span class="label-text font-semibold"> Raison sociale </span>
            </div>
          </h3>
          <div class="flex items-center" v-if="!isEditable && partner">
            <PartnerButtonRedirect
              :partner-id="partner?.id"
              :partner-name="partner?.name"
              class="btn-md"
            />
          </div>
          <div v-else>
            <SearchPartnerInput
              v-model="choosenPartner"
              class="flex-1"
              required
              :errorMessage="errors.partnerId"
            />
          </div>
        </div>
        <div
          class="divider divider-horizontal hidden md:flex"
          v-if="partner || choosenPartner"
        ></div>
        <div class="flex flex-col max-w-sm" v-if="partner || choosenPartner">
          <h3 class="card-title text-base mb-2">
            <div class="label">
              <span class="label-text font-semibold"> Indice de confiance </span>
            </div>
          </h3>
          <CreditSafeWithUpdateButton
            :partner-id="isEditable ? choosenPartner : partner?.id"
            class="self-start"
          />
        </div>
      </div>
    </div>
  </div>
</template>
